import * as moment from 'moment';
import { IListItem } from "@nkr/models/index"
import { IMicrositeEventLog } from "@nkr/models/microsites"
import { Label } from "react-bootstrap"
import { MicrositeEventType } from '@nkr/enums/microsite-event-type';
import { VoucherHolderType } from '@nkr/enums/voucher-holder-type';

interface TProps {
    logs:IMicrositeEventLog[],
    eventTypeList:IListItem[]
}
export default function VoucherTransplantDisplay({logs, eventTypeList}:TProps) {
    //const desc = eventTypeList.find(f => f.id == log?.eventType)?.abbreviation

    const labels = logs.map((l) => {

        if(l.eventType == MicrositeEventType.ReceivedVoucher) {
            let abv = "UV";
            let desc = "Unknown Voucher"; 
            if(l.voucherType == VoucherHolderType.StandardVoucher) {
                abv = "SV";
                desc = "Standard Voucher";
            }
            if(l.voucherType == VoucherHolderType.FamilyVoucher) {
                abv = "FV";
                desc = "Family Voucher";
            }
            return <><Label bsStyle="warning" title={`${desc} - ${moment(l.eventDate).format('MM/DD/YYYY')}`} >{abv}</Label>&nbsp;</>
        }

        if(l.eventType == MicrositeEventType.ReceivedLivingKidney || l.eventType == MicrositeEventType.LivingTxpOtherCenter) {
            return <><Label bsStyle="success" title={`TXP-LD - ${moment(l.eventDate).format('MM/DD/YYYY')}`} >TXP-LD</Label>&nbsp;</>
        }

        if(l.eventType == MicrositeEventType.ReceivedDeceasedKidney || l.eventType == MicrositeEventType.ReceivedDeceasedKidneyOtherCenter) {
            return <><Label bsStyle="success" title={`TXP-DD - ${moment(l.eventDate).format('MM/DD/YYYY')}`} >TXP-DD</Label>&nbsp;</>
        }

        const abbr = eventTypeList.find(f => f.id == l.eventType)?.abbreviation;
        return <><Label title={abbr ? `${abbr} - ${moment(l.eventDate).format('MM/DD/YYYY')}` : moment(l.eventDate).format('MM/DD/YYYY')}>{abbr ?? '?'}</Label>&nbsp;</>
    })

    return <>{labels}</>;
}